import { getContext } from '@fiverr-private/fiverr_context';
import { trackEvent } from '@fiverr-private/gtm';

const AFFILIATES_SIGN_UP_GTM_EVENTS = {
    PAGE_META_DATA: 'pageMetaData',
    SIGN_UP: 'sign-up',
    LINK_CLICK: 'linkClick',
    BUTTON_CLICK: 'buttonClick',
};

function getBaseEventParams() {
    const { userId, locale } = getContext();

    const localeSubstring = locale.substring(0, 2);

    const language = localeSubstring === 'pt' ? 'pt-br' : localeSubstring;

    return {
        environment: process.env.NODE_ENV,
        language,
        pageTitle: document.title,
        pageUrl: window.location.href,
        pagePath: window.location.pathname,
        pageType: 'Register',
        'signed-inUser': !!userId,
    };
}

type EventParams = Record<string, unknown>;

function trackAffiliatesSignUpEvent(event: string, extraParams?: EventParams) {
    return trackEvent(event, {
        ...getBaseEventParams(),
        ...extraParams,
    });
}

export function trackPageMetaData() {
    trackAffiliatesSignUpEvent(AFFILIATES_SIGN_UP_GTM_EVENTS.PAGE_META_DATA);
}

export function trackLinkClick(params: EventParams) {
    trackAffiliatesSignUpEvent(AFFILIATES_SIGN_UP_GTM_EVENTS.LINK_CLICK, params);
}

export function trackButtonClick(params: EventParams) {
    trackAffiliatesSignUpEvent(AFFILIATES_SIGN_UP_GTM_EVENTS.BUTTON_CLICK, params);
}

export function trackSignUp(params: EventParams) {
    trackAffiliatesSignUpEvent(AFFILIATES_SIGN_UP_GTM_EVENTS.SIGN_UP, params);
}
